import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = [<>
      Querer comer mejor, pero{' '}
      <span className="font-bold" data-id="element-103">no saber qué cocinar</span>
    </>, <>
      Terminás comiendo cualquier cosa por{' '}
      <span className="font-bold underline decoration-primary/40 decoration-2 underline-offset-2" data-id="element-104">
        falta de tiempo
      </span>
    </>, <>
      Te sentís{' '}
      <span className="font-bold underline decoration-accent decoration-2 underline-offset-2" data-id="element-105">
        inflamada, pesada o sin energía
      </span>{' '}
      después de comer
    </>, <>
      Probaste dejar el azúcar o la harina… pero{' '}
      <span className="font-bold bg-yellow-200/60 px-1 rounded" data-id="element-106">recaés</span>
    </>, <>
      Te da pereza pensar <span className="font-bold" data-id="element-107">todos los días</span> qué
      comer
    </>];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-charcoal" data-id="element-111">
            Probablemente te pasa que estás{' '}
            <span className="text-accent" data-id="element-112">cansada de:</span>
          </h2>

          <div className="space-y-6 bg-background p-8 md:p-10 rounded-2xl shadow-sm border border-gray-100" data-id="element-113">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start space-x-4" data-id="element-114">
                <XCircle className="text-pain flex-shrink-0 mt-1" size={24} data-id="element-115" />
                <p className="text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-116">
                  {point}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}